// Program Type Handler
// Handles showing/hiding program term and expiration date fields based on program type selection
// and program subscription level (for organizations)
// Used across multiple forms: organizations, reseller_locations, reseller_devices

(function () {
  'use strict';

  /**
   * Initialize program type handling on page load
   * @param {Object} options - Configuration options
   * @param {Array<string>} options.renewableTypes - Array of renewable program type symbols from ProgramType::RENEWABLE_SYMBOLS (required)
   */
  window.initializeProgramTypeHandler = function (options) {
    options = options || {};

    // Get renewable types from options (passed from Ruby via ProgramType::RENEWABLE_SYMBOLS)
    // These are the program types that require term and expiration date
    const renewableTypes = options.renewableTypes || [];
    if (renewableTypes.length === 0) {
      console.error('initializeProgramTypeHandler: renewableTypes is required but was not provided');
      return;
    }

    // Use standard selectors - all forms use the same IDs
    const programTypeSelector = '#program_type';
    const programTypeDivSelector = '#program_type_div';
    const termDivSelector = '#program_term_div';
    const expirationDivSelector = '#program_expiration_date_div';
    const subscriptionLevelSelector = '#program_subscription_level';

    // Handle initial state on page load
    $(document).ready(function () {
      const $programType = $(programTypeSelector);
      if ($programType.length === 0) return;

      const initialValue = $programType.val();
      // Only process if there's actually a value selected
      if (initialValue && initialValue !== '') {
        handleProgramTypeChange(initialValue, {
          renewableTypes: renewableTypes,
          programTypeDivSelector: programTypeDivSelector,
          termDivSelector: termDivSelector,
          expirationDivSelector: expirationDivSelector,
          subscriptionLevelSelector: subscriptionLevelSelector
        });
      }
    });

    // Handle changes to program type dropdown
    $(document).on('change', programTypeSelector, function () {
      const selectedValue = $(this).val();
      handleProgramTypeChange(selectedValue, {
        renewableTypes: renewableTypes,
        programTypeDivSelector: programTypeDivSelector,
        termDivSelector: termDivSelector,
        expirationDivSelector: expirationDivSelector,
        subscriptionLevelSelector: subscriptionLevelSelector
      });
    });

    // Handle changes to program subscription level (for organizations)
    $(document).on('change', subscriptionLevelSelector, function () {
      const $programType = $(programTypeSelector);
      const programTypeValue = $programType.val();

      // Re-evaluate visibility when subscription level changes
      if (programTypeValue && programTypeValue !== '') {
        handleProgramTypeChange(programTypeValue, {
          renewableTypes: renewableTypes,
          programTypeDivSelector: programTypeDivSelector,
          termDivSelector: termDivSelector,
          expirationDivSelector: expirationDivSelector,
          subscriptionLevelSelector: subscriptionLevelSelector
        });
      }
    });
  };

  /**
   * Handle program type change logic
   * Also checks program subscription level for organizations - only show fields when level is Organization (0)
   * @private
   */
  function handleProgramTypeChange(programType, options) {
    const $programTypeDiv = $(options.programTypeDivSelector);
    const $termDiv = $(options.termDivSelector);
    const $expirationDiv = $(options.expirationDivSelector);
    const $subscriptionLevel = $(options.subscriptionLevelSelector);

    // Program types that require term and expiration date (renewable types from ProgramType::RENEWABLE_SYMBOLS)
    const requiresTermAndDate = options.renewableTypes || [];

    // Check if subscription level selector exists (only for organizations)
    const hasSubscriptionLevel = $subscriptionLevel.length > 0;
    const subscriptionLevelValue = hasSubscriptionLevel ? $subscriptionLevel.val() : null;

    // Organization level is 0, Location is 1, Device is 2
    const ORGANIZATION_LEVEL = '0';
    const isOrganizationLevel = !hasSubscriptionLevel || subscriptionLevelValue === ORGANIZATION_LEVEL;

    // If subscription level is Location or Device, hide all program fields
    if (hasSubscriptionLevel && !isOrganizationLevel) {
      $programTypeDiv.hide();
      $termDiv.hide();
      $expirationDiv.hide();

      // Remove required attributes
      $programTypeDiv.find('select').attr('required', false);
      $termDiv.find('select').attr('required', false);
      $expirationDiv.find('input').attr('required', false);
      return;
    }

    // If we get here, either no subscription level (locations/devices forms) or Organization level
    // Show program type div for organization level
    if (hasSubscriptionLevel) {
      $programTypeDiv.show();
      $programTypeDiv.find('select').attr('required', true);
    }

    // Determine if we should show term and expiration fields based on program type
    const shouldShowFields = requiresTermAndDate.includes(programType);

    if (shouldShowFields) {
      // Show term and expiration date fields for renewable program types
      $termDiv.show();
      $expirationDiv.show();

      // Make fields required when visible
      $termDiv.find('select').attr('required', true);
      $expirationDiv.find('input').attr('required', true);
    } else {
      // Hide term and expiration date fields
      $termDiv.hide();
      $expirationDiv.hide();

      // Remove required attribute when hidden
      $termDiv.find('select').attr('required', false);
      $expirationDiv.find('input').attr('required', false);
    }
  }

})();
